class SportDetails extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const {signal} = this.controller;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.dataset.enhanced = '';
    const syncPreference = () => this.toggleAttribute('data-reduced-motion', this.reduced.matches);
    syncPreference();
    this.reduced.addEventListener('change', syncPreference, {signal});
    this.addEventListener('click', event => {
      const toggle = event.target.closest('[data-motion-toggle]');
      if (toggle) {
        const paused = this.toggleAttribute('data-motion-paused');
        toggle.setAttribute('aria-pressed', String(paused));
        const label = paused ? (this.dataset.labelPlay || 'Porne\u0219te anima\u021biile') : (this.dataset.labelPause || 'Opre\u0219te anima\u021biile');
        toggle.setAttribute('aria-label', label);
        toggle.title = label;
        toggle.querySelector('[data-motion-pause]').hidden = paused;
        toggle.querySelector('[data-motion-play]').hidden = !paused;
      }
      const zoom = event.target.closest('[data-feature-zoom]');
      if (zoom) {
        const dialog = this.querySelector('.eb-sport-feature-dialog');
        dialog.querySelector('img').src = zoom.dataset.featureZoom;
        dialog.querySelector('img').alt = zoom.querySelector('img').alt;
        dialog.showModal();
      }
      if (event.target.closest('[data-feature-close]')) event.target.closest('dialog').close();
    }, {signal});
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}
if (!customElements.get('eb-sport-strike')) customElements.define('eb-sport-strike', SportDetails);
